module.exports = __webpack_public_path__ + "static/media/close-palette18.7ec5abf2.svg";